{
  "INTEGRATION_APPS": {
    "FETCHING": "Dohvaćanje integracija",
    "NO_HOOK_CONFIGURED": "U ovom računu nema konfiguriranih {integrationId} integracija.",
    "HEADER": "Aplikacije",
    "STATUS": {
      "ENABLED": "Omogućeno",
      "DISABLED": "Onemogućeno"
    },
    "CONFIGURE": "Konfiguriraj",
    "ADD_BUTTON": "Dodaj novi hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Potvrdi brisanje",
        "ACCOUNT": "Prekini vezu"
      },
      "MESSAGE": {
        "INBOX": "Jeste li sigurni da želite izbrisati?",
        "ACCOUNT": "Jeste li sigurni da želite prekinuti vezu?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Da, izbriši",
        "ACCOUNT": "Da, prekini vezu"
      },
      "CANCEL_BUTTON_TEXT": "Odustani",
      "API": {
        "SUCCESS_MESSAGE": "Hook uspješno izbrisan",
        "ERROR_MESSAGE": "Povezivanje s chat poslužiteljem nije uspjelo. Pokušajte kasnije."
      }
    },
    "LIST": {
      "FETCHING": "Dohvaćanje integracijskih hookova",
      "INBOX": "Sandučić",
      "EDIT": {
        "BUTTON_TEXT": "Uredi"
      },
      "DELETE": {
        "BUTTON_TEXT": "Izbriši"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Odaberi sandučić",
          "PLACEHOLDER": "Odaberi sandučić"
        },
        "SUBMIT": "Izradi",
        "CANCEL": "Odustani"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integracijski hook uspješno dodan",
        "ERROR_MESSAGE": "Povezivanje s chat poslužiteljem nije uspjelo. Pokušajte kasnije."
      }
    },
    "EDIT": {
      "TITLE": "Uredi {name}",
      "FORM": {
        "INBOX": {
          "LABEL": "Odaberi sandučić",
          "PLACEHOLDER": "Odaberi sandučić"
        },
        "SUBMIT": "Ažuriraj",
        "CANCEL": "Odustani"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integracijski hook uspješno ažuriran",
        "ERROR_MESSAGE": "Povezivanje s chat poslužiteljem nije uspjelo. Pokušajte kasnije."
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Poveži"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Prekini vezu"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Dohvatite podatke s vlastitog poslužitelja i prikažite ih u bočnoj traci razgovora. Vraća HTML (prikazan u iframeu) ili JSON (prikazan kao popis ključ/vrijednost).",
      "DIALOGFLOW": "Dialogflow je platforma za obradu prirodnog jezika za izradu konverzacijskih sučelja. Integracija s {installationName} omogućuje botovima da prvi obrade upite i po potrebi ih proslijede agentima. Pomaže kvalificirati potencijalne klijente i smanjuje opterećenje agenata odgovaranjem na česta pitanja. Za dodavanje Dialogflowa kreirajte servisni račun (Service Account) u Google Consoleu i podijelite vjerodajnice. Pojedinosti potražite u dokumentaciji",
      "DAKTELA": "Sinkronizirajte e-mailove i web chatove s vašim daktela računom.",
      "RETINO": "Retino donosi red u upravljanje povratima i reklamacijama.",
      "MAILSHIP": "Mailship je sustav za upravljanje skladištem i ispunjavanjem narudžbi. Provjerite status narudžbe, praćenje i detalje otpreme.",
      "RAYNET": "Povežite svoj Raynet CRM račun za pristup podacima o klijentima. Dodajte vezu pomoću svog Raynet korisničkog imena i API tokena."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Testiraj vezu",
      "SUCCESS": "Veza uspješna",
      "ERROR": "Povezivanje nije uspjelo. Provjerite svoje vjerodajnice."
    }
  }
}
